import { render } from "./CardTwenty.vue?vue&type=template&id=4e58dc1f"
import script from "./CardTwenty.vue?vue&type=script&lang=js"
export * from "./CardTwenty.vue?vue&type=script&lang=js"

import "./CardTwenty.vue?vue&type=style&index=0&id=4e58dc1f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__